export default __webpack_public_path__ + "static/media/Car_Lora_Thumb_BMW_X3.293b758e.jpg";